import { fetchData } from "./fetch";

export const getLeaderBoard = async () => {
  try {
    const res = await fetchData(
      "get",
      "/leaderboard",
      {},
      { id: localStorage.getItem("id") }
    );
    return res;
  } catch (err) {
    return [];
  }
};
